import { useEffect } from 'react'
import { isNumber } from 'lodash'

import example from '../assets/images/normal-distribution-curve/example.png'

import { useSystemContext } from '../context/system-context'
import { useSetState } from './use-set-state'
import { localStorage } from '../utils/local-storage'

export const useAnalyseData = ({ analyse }) => {
  const { categories, dimensions } = useSystemContext()

  const [hookData, setHookData] = useSetState({
    seen: [],
    estimations: {},
    isLoading: true
  })

  useEffect(() => {
    // wait for the analyse
    if (!analyse) return

    const { _temp } = JSON.parse(analyse.input || '{}')

    if (_temp) setHookData({ ..._temp, isLoading: false })
    else setHookData({ isLoading: false })
  }, [analyse, setHookData])

  const { seen, estimations, isLoading } = hookData

  const result = {
    INTRO_0: {
      key: 'INTRO_0',
      title: 'intro.0.title',
      description: 'intro.0.description'
    },
    INTRO_1: {
      key: 'INTRO_1',
      title: 'intro.1.title',
      description: 'intro.1.description'
    },
    INTRO_2: {
      key: 'INTRO_2',
      title: 'intro.2.title',
      description: 'intro.2.description',
      attention: 'intro.2.attention'
    },
    INTRO_3: {
      key: 'INTRO_3',
      title: 'intro.3.title',
      description: 'intro.3.description',
      description_2: 'intro.3.description_2',
      attention: 'intro.3.attention',
      example
    },
    PERSONALITY: {
      ...categories.data['1'],
      dimensions: Object.keys(dimensions.data)
        .filter((key) => dimensions.data[key].category === 1)
        .map((key, index) => ({
          key,
          // the first dimension should be seen by default
          seen: index === 0 ? true : seen.includes(key),
          estimation: isNumber(estimations[key]) ? estimations[key] : -1,
          ...dimensions.data[key]
        }))
    },
    SKILLS: {
      ...categories.data['2'],
      dimensions: Object.keys(dimensions.data)
        .filter((key) => dimensions.data[key].category === 2)
        .map((key) => ({
          key,
          seen: seen.includes(key),
          estimation: isNumber(estimations[key]) ? estimations[key] : -1,
          ...dimensions.data[key]
        }))
    },
    INTERESTS: {
      ...categories.data['3'],
      dimensions: Object.keys(dimensions.data)
        .filter((key) => dimensions.data[key].category === 3)
        .map((key) => ({
          key,
          seen: seen.includes(key),
          estimation: isNumber(estimations[key]) ? estimations[key] : -1,
          ...dimensions.data[key]
        }))
    },
    OVERVIEW_INTRO: {
      key: 'OVERVIEW_INTRO',
      title: 'overview_intro.title',
      description: 'overview_intro.description'
    },
    OUTRO: {
      key: 'OUTRO',
      title: 'outro.title',
      description: 'outro.description',
      description_2: 'outro.description_2'
    }
  }

  return {
    isLoading,
    data: result,
    updateEstimation: ({ key, value }) => {
      const data = { ...estimations, [key]: value }
      const storageKey = `estimations-${analyse.id}`

      setHookData({ estimations: data })
      localStorage.setItem(storageKey, data)
    },
    setSeen: (key) => {
      const data = [...seen.filter((d) => d !== key), key]
      const storageKey = `seen-${analyse.id}`

      setHookData({ seen: data })
      localStorage.setItem(storageKey, data)
    }
  }
}
